import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {NgIf} from "@angular/common";
import {ServiceNotificationService} from "../../../services/service-notification.service";
import {NotificationsComponent} from "../../../notifications/notifications.component";
import {mostrarToast, ValidateCedula} from "../../../utils/utilities";
import {RestService} from "../../../services/rest.services.service";
import {environment} from "../../../../environments/environment"
import {RouterLink} from "@angular/router";

@Component({
  selector: 'app-form-pqrs',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    NgIf,
    NotificationsComponent,
    RouterLink,
  ],
  templateUrl: './form-pqrs.component.html',
  styleUrl: './form-pqrs.component.css'
})
export class FormPQRSComponent implements OnInit{


  constructor(
    private serviceNotificationService: ServiceNotificationService,
    private restService : RestService

) {
  }


  cedulaValid: boolean= false;


createPQRS = new FormGroup({
    identificacion: new FormControl('', [Validators.required,Validators.minLength(10), Validators.maxLength(15)]),
    name: new FormControl('', [Validators.required ,Validators.minLength(3), Validators.maxLength(50)]),
    surname: new FormControl('', [Validators.required ,Validators.minLength(3), Validators.maxLength(50)]),
    email: new FormControl('', [Validators.required ,Validators.email, Validators.maxLength(50)]),
    phone: new FormControl('', [Validators.required ,Validators.minLength(10), Validators.maxLength(15)]),
    message: new FormControl('', [Validators.required ,Validators.minLength(10), Validators.maxLength(500)])
  })



  ngOnInit() {


  }


  validatePQRS(){
    if(this.createPQRS.invalid){
      mostrarToast('Por favor asegurate de introducir todos los datos.', false, this.serviceNotificationService);

      return Object.values(this.createPQRS.controls).forEach(control => {
        control.markAsTouched();
      });
      // this.notifications.showToast()
    }
    mostrarToast('Enviando tu mensaje', true, this.serviceNotificationService);

    this.sendPQRS()
  }
  mostrarToast(message: string, type: boolean) {
    this.serviceNotificationService.recibeNotificacion.emit({
      mensaje: message,
      tipo: type
    })
  }

 async sendPQRS(){
  if (this.cedulaValid){

    this.restService.post({url: environment.apiSendPQRS, body: (this.createPQRS.value)})
      .subscribe((response: any) => {
        if (response.status != 200){
          mostrarToast('Ha ocurrido un error al enviar el mensaje, por favor intentalo nuevamente más tarde', false, this.serviceNotificationService);

        }
        mostrarToast('Mensaje enviado correctamente', true, this.serviceNotificationService);
        this.createPQRS.reset();
      })

      }else{
        mostrarToast('Por favor asegurate de introducir una cédula válida', false, this.serviceNotificationService);
  }
      }


  async validateCedulaFormPqrs(): Promise<Boolean> {
    const identificacion: string  = this.createPQRS.get('identificacion')?.value || "";
    this.cedulaValid =  ValidateCedula.validarCedula(identificacion);
    return this.cedulaValid;
  }
}

